// extracted by mini-css-extract-plugin
module.exports = {"buttonWrap":"Button_buttonWrap__3DZin","bounce":"Button_bounce__3DIDa"};